import './ConsentPage.css';
import SharkHeader from '../components/SharkHeader';

const ConsentPage = () => {
  const handleAllow = () => {
    const redirectURI = sessionStorage.getItem('redirectURI');
    if (!redirectURI) {
      return;
    }

    window.location.href = redirectURI;
  };

  const handleCancel = () => {
    const queryParams = window.location.search;
    window.location.href = 'https://doublecrunch.skegox.com/' + queryParams;
  };

  //   const handleBack = () => {
  //     window.history.back();
  //   };

  return (
    <div className="consent-shell">
      <div className="consent-container">
        {/* <button className="back-button" onClick={handleBack}>←</button> */}
        <SharkHeader />
        <h1 className="consent-title">Connect with Alexa</h1>
        <p className="consent-subtitle">Review permissions before linking your SharkClean account.</p>

        <div className="consent-card">
          <p className="consent-description">
            By choosing Allow, you permit the SharkClean Alexa skill to:
          </p>
          <ul className="consent-permissions">
            <li>Access your SharkClean account to control and monitor eligible devices.</li>
          </ul>

          <div className="consent-note">
            You can unlink this account anytime from the Alexa app.
          </div>

          <div className="consent-buttons">
            <button className="consent-allow" onClick={handleAllow}>Allow</button>
            <button className="consent-cancel" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentPage;
